"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var EditorTypes_1 = require("./EditorTypes");
var DebugEditorState_1 = require("./DebugEditorState");
var Sentry = __importStar(require("@sentry/browser"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Router = (function () {
    function Router(errorRecorder, usingFeature) {
        this.debug = false;
        this.behaviours = [];
        this.onChange = null;
        this.errorRecorder = errorRecorder;
        this.debug = usingFeature(FeatureFlag_1.default.EditorDebugLogging);
    }
    Router.prototype.register = function (behaviour) {
        if (!behaviour) {
            throw new Error("Tried to register a behaviour that does not exist");
        }
        this.behaviours.push(behaviour);
    };
    Router.prototype.onEvent = function (event, editor) {
        try {
            if (!this.onChange) {
                throw new Error("On change not attached to router");
            }
            switch (event.type) {
                case EditorTypes_1.EventType.Insert:
                case EditorTypes_1.EventType.Key:
                case EditorTypes_1.EventType.Copy:
                case EditorTypes_1.EventType.DragStart:
                case EditorTypes_1.EventType.Drop:
                case EditorTypes_1.EventType.DragOver:
                case EditorTypes_1.EventType.Click:
                case EditorTypes_1.EventType.Cut:
                case EditorTypes_1.EventType.DragEnd:
                    return this.triggerBehaviours(event, editor);
                case EditorTypes_1.EventType.Widget:
                case EditorTypes_1.EventType.Selection:
                case EditorTypes_1.EventType.SyntheticSelection:
                    var handled = this.triggerBehaviours(event, editor);
                    if (handled != null) {
                        this.onChange(editor.children);
                    }
                    return handled;
                default:
                    throw new Error("Got unsupported event type to router: ".concat(event.type));
            }
        }
        catch (error) {
            console.error(error.message);
            console.error(error.stack);
            var prunedEditorState = {};
            try {
                prunedEditorState = (0, DebugEditorState_1.getPrunedEditorState)(editor);
            }
            catch (_a) { }
            this.errorRecorder.recordError(error, prunedEditorState, { editorExceptionCategory: "routerBehaviours" });
            return true;
        }
    };
    Router.prototype.triggerBehaviours = function (event, editor) {
        var e_1, _a;
        var finalResult = null;
        try {
            for (var _b = __values(this.behaviours), _c = _b.next(); !_c.done; _c = _b.next()) {
                var behaviour = _c.value;
                var result = behaviour.action(event, editor);
                if (result == true) {
                    this.sendBreadcrumb(behaviour);
                    this.printEventHandlingResult(event, true, behaviour);
                    return result;
                }
                else if (result == false) {
                    finalResult = false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.printEventHandlingResult(event, false);
        return finalResult;
    };
    Router.prototype.printEventHandlingResult = function (event, wasHandled, behaviour) {
        if (!this.debug) {
            return;
        }
        var message = "";
        switch (event.type) {
            case EditorTypes_1.EventType.Key:
                message = "".concat(event.type, " with ").concat(event.key);
                break;
            default:
                message = "".concat(event.type);
        }
        var suffixStyle = ["color: grey;"];
        var suffix = "was not handled by any behaviours";
        if (wasHandled && behaviour) {
            suffix = "was handled by %c".concat(behaviour.name);
            suffixStyle = ["color: green;", "color: purple;"];
        }
        console.log.apply(console, __spreadArray(["".concat(message, " %c").concat(suffix)], __read(suffixStyle), false));
    };
    Router.prototype.sendBreadcrumb = function (behaviour) {
        Sentry.addBreadcrumb({
            message: "Triggered ".concat(behaviour.name),
            category: "editor",
            level: "info",
        });
    };
    return Router;
}());
exports.default = Router;
